import { isMobile } from "@common_lib/base/utils/src/tools"
import loadSetting from "@/utils/loadSetting"
import { safeLocalStorage } from "@/utils/safeStorage"
import { loadFile, loadDefaultFile } from "../../utils/loadWebsiteImage"

let modules: Map<string, string> | null = null
const isDevelopment = import.meta.env.VITE_DOMAIN_CHANGE === "true"

const createModules = async (websiteName: string) => {
  const deviceType = isMobile() ? "mobile" : "desktop"
  const forceCSSFileName = isDevelopment && safeLocalStorage.getItem("website")
  const fileName = forceCSSFileName || websiteName.toLowerCase()

  const setting = await loadSetting()
  const webSiteSetting = setting[fileName]

  if (!webSiteSetting) return

  const defaultFiles = await loadDefaultFile(deviceType)
  const specificFiles = await loadFile(deviceType, fileName)
  console.log("Default files loaded:", defaultFiles)
  console.log("Specific files loaded:", specificFiles)
  const fileModules = { ...defaultFiles, ...specificFiles }
  const template = webSiteSetting?.themes[deviceType]

  if (modules === null) modules = new Map()

  Object.entries(fileModules).forEach(([path, content]) => {
    const isWallpaper = path.match(/wallpaper-(.+?)\..|wallpaper\..+/)
    const isMask = path.match(/mask-(.+?)\..|mask\..+/)
    const isLogo = path.match(/logo\..+/)
    const isAppIc = path.match(/appic-(.+?)\..|appic\..+/)

    if (isWallpaper) {
      const [, matchTemplate] = isWallpaper
      const isTemplateWallpaper = matchTemplate === template
      const isCustomWallpaper = matchTemplate === undefined

      if ((isTemplateWallpaper && !modules?.has("wallpaper")) || isCustomWallpaper) {
        modules?.set("wallpaper", content)
      }
    } else if (isMask) {
      const [, matchTemplate] = isMask
      const isTemplateMask = matchTemplate === template
      const isCustomMask = matchTemplate === undefined

      if ((isTemplateMask && !modules?.has("mask")) || isCustomMask) {
        modules?.set("mask", content)
      }
    } else if (isLogo) {
      const isDefaultLogo = /\/share\//.test(path)
      const isCustomLogo = !isDefaultLogo

      if ((isDefaultLogo && !modules?.has("logo")) || isCustomLogo) {
        modules?.set("logo", content)
      }
    } else if (isAppIc) {
      modules?.set("appic", content)
    } else {
      modules?.set(path, content)
    }
  })

  console.log("Image modules created:", modules)
}

// Export initialization function to be called from main.js
export const initImageModules = async (websiteName: string) => {
  await createModules(websiteName)
}

export const useImages = () => {
  const findFile = (url: string) => {
    if (modules === null) {
      console.error(
        "Error: Images Modules is not created yet. Call initImageModules first."
      )
      return null
    }
    if (!modules.has(url)) {
      try {
        const file = modules.get(`custom_${url}`)
        if (!file) throw new Error()
        return file
      } catch {
        console.error("Error: URL is wrong path", url)
        return null
      }
    } else {
      return modules.get(url) ?? null
    }
  }

  return {
    findFile
  }
}

export default useImages
